import { HorizontalSpacer, Label,  DataDisplayEvent,  DataSourceExecutionEvent } from "@mcleod/components";
import { AutogenLayoutInvoiceHistoryChargesQuickInfo } from "./autogen/AutogenLayoutInvoiceHistoryChargesQuickInfo";
import { CurrencySettings, CurrencyUtil, DisplayType } from "@mcleod/core";

export class InvoiceHistoryChargesQuickInfo extends AutogenLayoutInvoiceHistoryChargesQuickInfo {
    onOtherChargeBillAfterExecute() {
        if (this.sourceOtherChargeEdi?.data?.length === 0) {
            this.panelOtherChargesRows.visible = false;
            this.labelOtherCharges.visible = false;
        } else {
            this.panelOtherChargesRows.visible = true;
            this.labelOtherCharges.visible = true;
            this.sourceOtherChargeEdi?.data.forEach(result => {
                const description = new Label({text: result.get("descr"), rowBreak: false, marginBottom: 4, displayType: DisplayType.STRING, width: 125, color: "default.light" })
                this.panelOtherChargesRows.add(description);
                this.panelOtherChargesRows.add(new HorizontalSpacer({marginBottom: 4}));
                const amount = new Label({fillRow: true, text: CurrencyUtil.formatCurrency(result.get("amount")), rowBreak: true, marginBottom: 4, displayType: DisplayType.CURRENCY, color: "default.light"})
                this.panelOtherChargesRows.add(amount);
            });

        }
        if (CurrencySettings.getSingleton().multiCurrencyEnabled()) {
            this.labelTaxCharges.visible = true;
            this.labelTaxChargesTotal.visible = true;
            this.horizontalspacerTaxes.visible = true;
            this.labelTotalChargesWithTaxes.visible = true;
            this.labelTotalChargesWithTaxesTotal.visible = true;
            this.horizontalspacerTotalWithTaxes.visible = true;
        }
    }

    onInvoiceMarginsAfterExecute() {
        this.panelCarrier.visible = true;
    }
}
